// Тексты фонового коммита загрузки в блок (`useBlockUploadCommit`) — по виду
// файла. Коммит общий для картинки и ролика, а тост обязан назвать, ЧТО именно
// не сохранилось: «картинка не сохранена» после загрузки видео соврало бы.
import { defineMessages, messagesNow } from '@/i18n'
import { reviewUploadRefused } from '../../lib/reviewLockText'
import { messages } from './messages'

export type UploadKind = 'image' | 'video'

export interface UploadCommitText {
  run: string
  review: string
  dirty: string
  gone: string
  noPlace: string
  failed: string
  saved: string
}

const videoMessages = defineMessages({
  ru: {
    run:
      'Видео загружено, но не сохранено: блок сейчас переписывает AI. ' +
      'Загрузите его ещё раз, когда AI закончит.',
    review: 'Курс на проверке — видео не сохранено',
    dirty:
      'Видео загружено, но не сохранено: в блоке есть несохранённые правки. ' +
      'Сохраните блок и загрузите видео ещё раз.',
    gone: 'Видео загружено, но блока уже нет — сохранять его некуда.',
    noPlace: 'Видео загружено, но сохранить его в этот блок нельзя.',
    failed: 'Видео загружено, но сохранить его в блок не удалось.',
    saved: 'Видео загружено и сохранено в блок',
  },
  en: {
    run:
      'The video was uploaded but not saved: AI is rewriting this block right now. ' +
      'Upload it again once AI is done.',
    review: 'The course is under review — the video wasn’t saved',
    dirty:
      'The video was uploaded but not saved: the block has unsaved changes. ' +
      'Save the block and upload the video again.',
    gone: 'The video was uploaded, but the block no longer exists — nowhere to save it.',
    noPlace: 'The video was uploaded, but it can’t be saved to this block.',
    failed: 'The video was uploaded, but it couldn’t be saved to the block.',
    saved: 'Video uploaded and saved to the block',
  },
})

/** Читается в момент коммита: тост уходит позже рендера. */
export const uploadCommitText = (kind: UploadKind): UploadCommitText => {
  if (kind === 'video') return messagesNow(videoMessages)
  const m = messagesNow(messages)
  return {
    run: m.uploadRun,
    review: reviewUploadRefused(),
    dirty: m.uploadDirty,
    gone: m.uploadGone,
    noPlace: m.uploadNoPlace,
    failed: m.uploadFailed,
    saved: m.uploadSaved,
  }
}
